import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = {
  mainBook: "https://cdn.magicpatterns.com/uploads/v1QsaVpyY9GH4JQ5gaVfgx/ChatGPT_Image_27_ago_2026,_17_18_39.webp",
  packCompleto: "https://cdn.magicpatterns.com/uploads/pYiYocj2orM7TxQmykg8r4/ChatGPT_Image_27_ago_2026,_17_16_32.webp",
  bonus1: "https://cdn.magicpatterns.com/uploads/iTZkkpLUE3e6LsQYEsvkdQ/ChatGPT_Image_27_ago_2026,_18_19_26.webp",
  bonus2: "https://cdn.magicpatterns.com/uploads/65MtA98jpsW7xj65LQHk5G/ChatGPT_Image_27_ago_2026,_17_29_24.webp",
  bonus3: "https://cdn.magicpatterns.com/uploads/d3cryZbVaxu2SKdXnovqPQ/ChatGPT_Image_27_ago_2026,_18_21_33.webp",
  bonus4: "https://cdn.magicpatterns.com/uploads/hLfmvemPTEnGcXMUEK3B1y/Diseno_sin_titulo.jpg",
  bonus5: "https://cdn.magicpatterns.com/uploads/nAKZyikiLP9FfPqFyYFrui/Diseno_sin_titulo_(1).jpg",
  sample1: "https://cdn.magicpatterns.com/uploads/1ULH7f1FmH675nFxVrneGL/capture_260827_190244.webp",
  sample2: "https://cdn.magicpatterns.com/uploads/dgmtKHaUo8xWzxK2bTkTL5/capture_260827_190235.webp",
  sample3: "https://cdn.magicpatterns.com/uploads/waAh3auNGD1fAwoapocMQj/capture_260827_190158.webp",
  sample4: "https://cdn.magicpatterns.com/uploads/4FKGaBZFVNJRdVKWwvMjoH/capture_260827_190150.webp",
  sample5: "https://cdn.magicpatterns.com/uploads/tTWrussu1pQDMr7PaKPGj9/capture_260827_190141.webp"
};
const GameDecoration = ({
  type,
  className,
  style
}: {
  type: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  let svgContent = null;
  switch (type) {
    case 'pickaxe':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-0" data-mp="38li7lebna3n2">
          <path d="M14 2v4h-1V4h-2V3H7V2h7z" fill="#55FFFF" data-id="element-1" data-mp="nvstx4mognvy" />
          <path d="M13 3v2h-1V4h-1V3h2z" fill="#FFFFFF" data-id="element-2" data-mp="nvasltl5rjh6" />
          <path d="M14 1h1v6h-1v1h-1v1h-1V8h1V6h1V2h-4v1H8v1H7v1H6V4h1V3h2V2h3V1h2z" fill="#111" data-id="element-3" data-mp="stuczpk3sn7f" />
          <path d="M11 5h2v2h-2V5zm-2 2h2v2H9V7zM7 9h2v2H7V9zM5 11h2v2H5v-2zM3 13h2v2H3v-2z" fill="#8B6346" data-id="element-4" data-mp="35ox2qy1z4t4" />
          <path d="M10 6h1v1h-1V6zm-2 2h1v1H8V8zm-2 2h1v1H6v-1zm-2 2h1v1H4v-1zm-2 2h1v1H2v-1z" fill="#5C4033" data-id="element-5" data-mp="3ubrgyizwqe3g" />
          <path d="M12 5h1v2h-1V5zm-2 2h1v2h-1V7zM8 9h1v2H8V9zM6 11h1v2H6v-2zM4 13h1v2H4v-2z" fill="#111" data-id="element-6" data-mp="d3cwhu6lt0hm" />
          <path d="M6 3h1v1H6V3zM12 9h1v1h-1V9z" fill="#111" data-id="element-7" data-mp="8648hcyry28g" />
        </svg>;
      break;
    case 'diamond':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-8" data-mp="3bmbevr8kqdkx">
          <path d="M7 1h2v1h2v1h1v2h1v6h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V5h1V3h1V2h2V1z" fill="#111" data-id="element-9" data-mp="3qdai0mqn49x4" />
          <path d="M7 2h2v1h2v1h1v2h1v5h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V6h1V4h1V3h2V2z" fill="#55FFFF" data-id="element-10" data-mp="3lieg8uvlq86t" />
          <path d="M6 3h3v1h1v1h1v2h-1V5H9V4H6V3z" fill="#FFFFFF" data-id="element-11" data-mp="2xsk2mb3gkfli" />
          <path d="M11 7v4h-1v2h-2v1H7v-1h2v-1h1V7h1z" fill="#00AAAA" data-id="element-12" data-mp="2sv0mf5n79sqx" />
        </svg>;
      break;
    case 'emerald':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-13" data-mp="1d4hod823dg7z">
          <path d="M6 1h4v2h2v2h1v6h-1v2h-2v2H6v-2H4v-2H3V5h1V3h2V1z" fill="#111" data-id="element-14" data-mp="ydikgac7bfuq" />
          <path d="M6 2h4v2h2v2h1v4h-1v2h-2v2H6v-2H4v-2H3V6h1V4h2V2z" fill="#55FF55" data-id="element-15" data-mp="13ey3xxyqdeb0" />
          <path d="M6 3h3v1h1v2h-1V4H6V3z" fill="#FFFFFF" data-id="element-16" data-mp="1r5kb7n0wuujy" />
          <path d="M10 11v2H6v-1h4v-1z" fill="#00AA00" data-id="element-17" data-mp="1w33p2ltp55bd" />
        </svg>;
      break;
    case 'torch':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-18" data-mp="1i2j8zxf61nlk">
          <path d="M7 4h2v10H7V4z" fill="#111" data-id="element-19" data-mp="6nw3ptdfo9bg" />
          <path d="M7 6h2v8H7V6z" fill="#8B6346" data-id="element-20" data-mp="6n4agp7b6noc" />
          <path d="M7 4h2v2H7V4z" fill="#FFAA00" data-id="element-21" data-mp="aqitzpughm6j" />
          <path d="M7 3h2v1H7V3z" fill="#FFFF55" data-id="element-22" data-mp="arbysl9uu1m1" />
          <path d="M7 2h2v1H7V2z" fill="#FFFFFF" data-id="element-23" data-mp="qxf7vqfa53ia" />
        </svg>;
      break;
    case 'grass-block':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-24" data-mp="m4uh6xro76iz">
          <path d="M1 1h14v14H1V1z" fill="#111" data-id="element-25" data-mp="c9an8gwo2hwv" />
          <path d="M2 5h12v9H2V5z" fill="#8B6346" data-id="element-26" data-mp="c6eo4p931n6u" />
          <path d="M2 2h12v3H2V2z" fill="#55A83C" data-id="element-27" data-mp="19uyiuzlasw7c" />
          <path d="M2 2h12v1H2V2z" fill="#75C765" data-id="element-28" data-mp="19tnfh0vrlqgr" />
          <path d="M2 5h1v1h2V5h2v2h2V5h2v1h2V5h1v1h-1v1h-1V6h-2v1H8V6H6v1H4V6H3v1H2V5z" fill="#55A83C" data-id="element-29" data-mp="14xyequ80e3iv" />
        </svg>;
      break;
    case 'chest':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-30" data-mp="vwruqb65iakv">
          <path d="M1 3h14v10H1V3z" fill="#111" data-id="element-31" data-mp="3gmh8ekv4bqbz" />
          <path d="M2 4h12v8H2V4z" fill="#A67B5B" data-id="element-32" data-mp="3glob0ai1ud6i" />
          <path d="M2 4h12v1H2V4zm0 3h12v1H2V7zm0 4h12v1H2v-1zM2 4h1v8H2V4zm11 0h1v8h-1V4z" fill="#3A2418" data-id="element-33" data-mp="1w4ezsdi9wtib" />
          <path d="M7 6h2v3H7V6z" fill="#111" data-id="element-34" data-mp="205qsirwg1uuq" />
          <path d="M7 6h2v2H7V6z" fill="#CCCCCC" data-id="element-35" data-mp="206jrh6p5vg2b" />
        </svg>;
      break;
    case 'pig':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-36" data-mp="2530kofb7wkm9">
          <path d="M3 4h10v8H3V4z" fill="#111" data-id="element-37" data-mp="2eueqt5xociod" />
          <path d="M4 5h8v6H4V5z" fill="#FFAAFF" data-id="element-38" data-mp="2jtrc3m8wdhou" />
          <path d="M6 8h4v2H6V8z" fill="#FF55FF" data-id="element-39" data-mp="2jsg8bmfgc9xq" />
          <path d="M5 7h1v1H5V7zm4 0h1v1H9V7z" fill="#111" data-id="element-40" data-mp="2nv323svoo4xk" />
          <path d="M4 7h1v1H4V7zm4 0h1v1H8V7z" fill="#FFFFFF" data-id="element-41" data-mp="2nti7k39dclzp" />
        </svg>;
      break;
    case 'gold':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-42" data-mp="thtrtyvbcfe9">
          <path d="M5 3h6v2h2v6h-2v2H5v-2H3V5h2V3z" fill="#111" data-id="element-43" data-mp="yihn4wqkriea" />
          <path d="M5 4h6v2h2v4h-2v2H5v-2H3V6h2V4z" fill="#FFAA00" data-id="element-44" data-mp="21s3xr4y8osn5" />
          <path d="M5 5h4v1h1v2h-1V6H5V5z" fill="#FFFF55" data-id="element-45" data-mp="1wt96rfq4bxry" />
          <path d="M9 9v2H5V9h4z" fill="#AA5500" data-id="element-46" data-mp="1wuu0520p5ao8" />
        </svg>;
      break;
    case 'trophy':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-47" data-mp="25tfiox664pp0">
          <path d="M4 2h8v5H4V2zm-2 2h2v3H2V4zm10 0h2v3h-2V4zm-7 5h2v4H5v-4zm-1 4h6v2H4v-2z" fill="#111" data-id="element-48" data-mp="2ko3lg3k6pa0x" />
          <path d="M5 3h6v3H5V3zm-2 2h1v1H3V5zm10 0h1v1h-1V5zm-6 4h2v3H7V9zm-2 4h6v1H5v-1z" fill="#FFAA00" data-id="element-49" data-mp="2tiqiocfp2g23" />
          <path d="M5 3h2v1H5V3zm-2 2h1v1H3V5z" fill="#FFFF55" data-id="element-50" data-mp="2phet26wtlutw" />
        </svg>;
      break;
    default:
      return null;
  }
  return <div className={`absolute pointer-events-none z-[1] ${className}`} style={style} data-id="element-51" data-mp="33hph726qwvbd">
      {svgContent}
    </div>;
};
const CTAButton = ({
  text = "QUIERO ACCEDER AHORA 🎮",
  className = ""
}) => <div className={`flex flex-col items-center w-full ${className}`} data-id="element-52" data-mp="3i463tc4vk36k">
    <a href="https://www.aprendejugando.shop/cart/43083545313355:1" className="btn-pixel w-full py-4 md:py-5 px-4 text-2xl md:text-3xl flex items-center justify-center text-center leading-tight shadow-[0_6px_0_#111] active:shadow-[0_0px_0_#111] active:translate-y-[6px] no-underline" data-id="element-53" data-mp="3n2zj9a3q249d">
      {text}
    </a>
    <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 mt-3 text-[12px] font-body font-bold text-[#111]" data-id="element-54" data-mp="2zcvirbltykml">
      <span data-id="element-55" data-mp="344n85it92kb5">⚡ Acceso inmediato</span>
      <span data-id="element-56" data-mp="345ombw5kbmx3">·</span>
      <span data-id="element-57" data-mp="2pf7kwcsxgx07">📄 PDF</span>
      <span data-id="element-58" data-mp="2pg0j2pdtme6q">·</span>
      <span data-id="element-59" data-mp="2pgin486q5wp7">🖨️ Imprimible</span>
      <span data-id="element-60" data-mp="2pd4kcyu5flh8">·</span>
      <span data-id="element-61" data-mp="2udsie4gsp2ky">🔒 Pago seguro</span>
    </div>
  </div>;
const AutoScrollCarousel = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const scroll = () => {
      if (!isHovered) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isHovered]);
  const samples = [IMAGES.sample1, IMAGES.sample2, IMAGES.sample3, IMAGES.sample4, IMAGES.sample5];
  return <div className="w-full relative py-8 overflow-hidden bg-minecraft-landscape bg-cover bg-center border-y-4 border-[#111]" data-id="element-62" data-mp="2d5t1vsv3w5wd">
      <div className="absolute inset-0 bg-[#1A365D]/85" data-id="element-63" data-mp="285wwbp6rg6ep"></div>
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="font-display text-[26px] md:text-[32px] text-white text-outline text-center mb-8 uppercase relative z-10" data-id="element-64" data-mp="284dbrme2n974">
        UN VISTAZO POR DENTRO 👀
      </motion.h2>
      <div ref={scrollRef} className="flex gap-6 overflow-x-auto hide-scrollbar px-4 pb-4 snap-x relative z-10" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-65" data-mp="9pfnv4udtooy">
        {[...samples, ...samples, ...samples].map((src, i) => <div key={i} className="w-[260px] md:w-[320px] flex-shrink-0 bg-white pixel-border hard-shadow p-2 snap-center cursor-grab active:cursor-grabbing hover:-translate-y-2 transition-transform duration-300" data-id="element-66" data-mp="3m6tadr2x58u5" data-mpi={i}>
            <img src={src} alt={`Muestra ${i}`} className="w-full h-auto object-cover border-2 border-[#111]" data-id="element-67" data-mp="3w47bmjg9tr1v" />
          </div>)}
      </div>
    </div>;
};
const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Florencia', 'Sofía', 'Camila', 'Valeria', 'Romina', 'Luciana', 'Paula', 'Daniela', 'Carolina', 'Mariana', 'Julieta', 'Agustina'];
  const locations = ['Palermo', 'Belgrano', 'Caballito', 'Recoleta', 'Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'La Plata', 'Almagro', 'Vicente López', 'San Isidro', 'Quilmes', 'Neuquén', 'Tucumán'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 3 minutos', 'hace 8 minutos', 'hace 15 minutos'];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setCurrentBuyer({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);

      // Schedule next popup between 10 and 20 seconds later
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-68" data-mp="3hz7pkrury902">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white pixel-border hard-shadow-sm p-3 flex items-center gap-3 max-w-[300px]" data-id="element-69" data-mp="3d0mraxz31ze9">
          <div className="bg-grass-green w-10 h-10 flex-shrink-0 flex items-center justify-center pixel-border animate-gift-pop" data-id="element-70" data-mp="2ua575hsbgc4i">
            <span className="text-xl" data-id="element-71" data-mp="2pc3gaaonf8ih">🎁</span>
          </div>
          <div className="flex flex-col" data-id="element-72" data-mp="2fng270fap6qq">
            <p className="font-body font-bold text-[13px] text-[#171717] leading-tight" data-id="element-73" data-mp="2fmerwy63soa2">
              <span className="text-grass-green font-black" data-id="element-74" data-mp="2kmsw254l3e2t">{currentBuyer.name}</span> de {currentBuyer.location} acaba de comprar el pack.
            </p>
            <p className="font-body font-bold text-[11px] text-gray-500 mt-0.5" data-id="element-75" data-mp="26p4f38dn0r31">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export function App() {
  const faqs = [{
    q: "¿Qué recibo exactamente?",
    a: "Recibís un archivo digital (PDF) con más de 100 actividades de matemáticas, además de los 5 bonos exclusivos detallados en la página."
  }, {
    q: "¿Es un producto físico?",
    a: "No, es un producto 100% digital. Lo recibís en tu correo electrónico listo para descargar e imprimir las veces que quieras."
  }, {
    q: "¿Para qué edades sirve?",
    a: "El material está diseñado para niños que cursan entre 1.º y 5.º grado de primaria (aprox. 6 a 11 años), con niveles de dificultad progresivos."
  }, {
    q: "¿Puedo imprimir las actividades?",
    a: "¡Sí! Está diseñado específicamente para ser impreso. Podés imprimir todo el libro o solo las hojas que necesites en el momento."
  }, {
    q: "¿Puedo utilizarlo más de una vez?",
    a: "Al ser un archivo digital, podés imprimir las actividades todas las veces que necesites para tu hijo o tus alumnos."
  }, {
    q: "¿Sirve para docentes?",
    a: "Absolutamente. Muchos docentes utilizan este material en el aula como una forma divertida de repasar conceptos o como actividades de extensión."
  }, {
    q: "¿Necesito tener Minecraft?",
    a: "No, no es necesario tener el juego ni saber jugarlo. Las actividades usan la estética y temática visual para hacerlas más atractivas, pero se resuelven en papel."
  }, {
    q: "¿Cómo recibo el material?",
    a: "Inmediatamente después de confirmar el pago, recibirás un correo electrónico con los enlaces para descargar todo el material."
  }];
  return <div className="min-h-screen bg-[#111] flex justify-center font-body" data-id="element-76" data-mp="hmth3kdihget">
      <SalesPopup data-id="element-77" data-mp="howg2twn6jvo" />
      {/* Main Container - Narrow centered sales page */}
      <div className="w-full max-w-[800px] bg-sky-blue relative shadow-[0_0_30px_rgba(0,0,0,0.8)] overflow-hidden" data-id="element-78" data-mp="mmg2wi7eo4z8">
        
        {/* 1. HERO */}
        <section className="w-full bg-minecraft-landscape relative pb-8 overflow-hidden" style={{
        paddingBottom: "0px"
      }} data-id="element-79" data-mp="vmcno8qocjp0">
          {/* Decorative Elements */}
          <GameDecoration type="pickaxe" className="w-[70px] md:w-[90px] -left-[20px] top-[38%] -rotate-[20deg]" data-id="element-80" data-mp="10lfi6z9137iq" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] right-[15px] top-[55%] animate-game-float" data-id="element-81" data-mp="15ifmb4mbi077" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[60px] right-[10%] bottom-[10%]" data-id="element-82" data-mp="1ecucw3casx5m" />

          {/* Top Strip */}
          <div className="bg-dark-brown text-white font-body font-bold text-[11px] md:text-sm h-[38px] px-4 flex justify-between items-center border-b-4 border-[#111] relative z-10" data-id="element-83" data-mp="1jd898o4jeint">
            <span data-id="element-84" data-mp="1yfgqr38gr090">🎮 MATEMÁTICAS EN MODO JUEGO</span>
            <span className="text-[#FFC928]" data-id="element-85" data-mp="1yd40m2sjxjkv">OFERTA ESPECIAL</span>
          </div>

          <div className="px-4 pt-5 pb-2 text-center flex flex-col items-center relative z-10" data-id="element-86" data-mp="1tespzpufn51l">
            {/* Small Badge */}
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center justify-center bg-yellow-pixel text-[#111] font-body font-black text-[11px] md:text-sm px-3 h-[32px] pixel-border hard-shadow-sm mb-4 uppercase leading-none" data-id="element-87" data-mp="1kffekrmr06e8">
              🎮 +100 ACTIVIDADES · 1.º A 5.º DE PRIMARIA
            </motion.div>
            
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-display text-[34px] md:text-6xl lg:text-7xl text-white text-outline leading-[1.05] tracking-tight mb-3 uppercase max-w-[95%] animate-mc-breathe" data-id="element-88" data-mp="23e1i0d5qm9lb">
              ¿TU HIJO AMA MINECRAFT<br data-id="element-89" data-mp="y7jpuwom7fxy" />
              PERO NO LAS <span className="text-[#FFC928]" data-id="element-90" data-mp="y6h1averlpl7">MATEMÁTICAS</span>?
            </motion.h1>
            
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#111] text-[16px] leading-[1.3] max-w-[340px] mx-auto mb-4" data-id="element-91" data-mp="jg9qn1v01av2">
              Convertí la práctica en misiones y desafíos que realmente tenga ganas de completar.
            </motion.p>
            
            {/* Product Image - HUGE */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="w-[112%] -ml-[6%] md:w-full md:ml-0 mt-2 mb-6" data-id="element-92" data-mp="5htbcmj2mc1b">
              <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-full md:w-[95%] mx-auto block drop-shadow-2xl animate-float" data-id="element-93" data-mp="1zvb2ejiopr13" />
            </motion.div>
            
            {/* Dark Panel */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-dark-brown text-white font-body font-black text-[14px] md:text-lg h-[50px] flex items-center justify-center px-3 pixel-border hard-shadow w-full max-w-[95%] mb-5 uppercase tracking-wide" data-id="element-94" data-mp="3fgmp3mx1my1f">
              +100 ACTIVIDADES • 5 NIVELES • 5 BONOS GRATIS
            </motion.div>
            
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="w-full max-w-[95%]" data-id="element-95" data-mp="gxftfwv1gdme">
              <CTAButton data-id="element-96" data-mp="2ip17q3tx78ow" />
            </motion.div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-97" data-mp="2dqhm64j8nyx2">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-98" data-mp="2ds2le7gi0619"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-99" data-mp="1rw99bhnpxwfl"></div>
        </div>

        {/* 2. PROBLEMA */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-100" data-mp="1wtsmsfcle56h">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-display text-[30px] md:text-[40px] text-[#111] text-center mb-6 uppercase leading-tight relative z-10" data-id="element-101" data-mp="21n3x4qgm5435">
            ¿TU HIJO AMA LOS JUEGOS...<br data-id="element-102" data-mp="1dz3x0zxew1bw" />
            <span className="text-[#E53E3E]" data-id="element-103" data-mp="1iw41x7iiyy1f">PERO LAS MATEMÁTICAS LE PARECEN ABURRIDAS?</span>
          </motion.h2>
          
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-lg text-center mb-8 text-[#302A26] relative z-10" data-id="element-104" data-mp="1nvh0gpirdtju">
            Sentarlo a practicar no debería convertirse todos los días en una negociación.
          </motion.p>
          
          <div className="flex flex-col gap-4 mb-10 max-w-[90%] mx-auto relative z-10" data-id="element-105" data-mp="ine4estfm4ly">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-106" data-mp="dwxpt5dvkcy0">
              <span className="text-3xl" data-id="element-107" data-mp="3zt1p00gy7ek">😩</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-108" data-mp="3w2ty5h3lcwbt">Se aburre rápidamente</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-109" data-mp="3r37jd384780w">
              <span className="text-3xl" data-id="element-110" data-mp="1pbugsktmdc80">🧠</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-111" data-mp="1kdj84df297rd">Pierde la concentración</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-112" data-mp="2c7lzxg037d64">
              <span className="text-3xl" data-id="element-113" data-mp="22fq1u4y03n1w">📚</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-114" data-mp="1xiznbm1ugzil">Los ejercicios tradicionales no logran engancharlo</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-yellow-pixel pixel-border hard-shadow p-6 text-center max-w-[95%] mx-auto relative z-10" data-id="element-115" data-mp="1ohrmoxbuvmlc">
            <h3 className="font-body font-black text-xl mb-2 text-[#171717]" data-id="element-116" data-mp="3dwpqmql53jr6">¿Y si en lugar de luchar contra lo que le gusta... lo usamos a nuestro favor?</h3>
            <p className="font-body font-black text-[24px] md:text-[28px] text-[#171717] uppercase mt-4" data-id="element-117" data-mp="38y4q0q1z6y27">
              TRANSFORMÁ LA PRÁCTICA EN UNA MISIÓN.
            </p>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-118" data-mp="3q6xgpkijqik0">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-119" data-mp="3q7gzf3g0taz3"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-120" data-mp="3v4z4giqx361t"></div>
        </div>

        {/* 3. PRESENTACIÓN DEL PRODUCTO */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-121" data-mp="2yhugcfts5scn">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-4 leading-tight relative z-10" data-id="element-122" data-mp="32hmq2vuwu4jl">
            CONOCÉ +100 ACTIVIDADES DE MATEMÁTICAS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-lg bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-123" data-mp="ro8r1it09qq3">
            Una forma diferente de practicar matemática aprovechando un universo que los chicos ya conocen y disfrutan.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-[85%] max-w-[400px] mx-auto mb-10 relative z-10" data-id="element-124" data-mp="3ffsx72pmtjai">
            <img src={IMAGES.mainBook} alt="Libro Principal" className="w-full block drop-shadow-2xl animate-float" data-id="element-125" data-mp="3p76tz2q784zy" />
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 text-left max-w-[95%] mx-auto relative z-10" data-id="element-126" data-mp="2woro3luss7d8">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-127" data-mp="2rpezavkd8q80">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-128" data-mp="1c0ql08yslzrk">🎮 APRENDER JUGANDO</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-129" data-mp="x8f3bolu05wx">Actividades presentadas como desafíos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-130" data-mp="1q08fn4yrs78u">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-131" data-mp="1gxz8mp2pmw07">🧠 PRACTICAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-132" data-mp="5j3hw4qsh43a">Conceptos fundamentales de matemática.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.5
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-133" data-mp="9lgqd0wx7g3r">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-134" data-mp="kzsdk8u4x0g7">🏆 AVANZAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-135" data-mp="b2xffr1rx22g">Cada actividad se convierte en un nuevo logro.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-136" data-mp="18q5x1aynlqz6">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-137" data-mp="yuky5lovt6tn">🖨️ IMPRIMIR Y USAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-138" data-mp="3jih7imqpkefx">Elegí las actividades que necesites.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="max-w-[90%] mx-auto relative z-10" data-id="element-139" data-mp="1uz36y37iokaw">
            <CTAButton data-id="element-140" data-mp="23zrmx3gh0uqf" />
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-141" data-mp="28qhp67tlohgw"></div>

        {/* 4. MOSTRAR LAS ACTIVIDADES */}
        <section className="bg-[#1A365D] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-142" data-mp="2dpumxnm0f8y9">
          {/* Decorative Elements */}
          <GameDecoration type="pig" className="w-[60px] md:w-[80px] top-[20%] right-[5%] md:right-[15%] rotate-12" data-id="element-143" data-mp="2imuih4l8gtb4" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] bottom-[20%] left-[5%] md:left-[15%] animate-game-float" data-id="element-144" data-mp="2mo6f3u2iyest" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[22px] md:text-2xl text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-145" data-mp="scrkayunpp67">NO ES SOLO UN LIBRO...</motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-black text-[28px] md:text-[34px] text-white uppercase mb-10 leading-tight relative z-10" data-id="element-146" data-mp="1vogtifhji0ve">
            SON +100 ACTIVIDADES PARA RESOLVER, PRACTICAR Y SUPERAR
          </motion.h3>
          
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} src={IMAGES.packCompleto} alt="Hojas de actividades" className="w-[95%] mx-auto block drop-shadow-2xl mb-10 relative z-10" data-id="element-147" data-mp="2el88wdtynvu6" />
          
          <div className="flex flex-wrap justify-center gap-2 max-w-[95%] mx-auto relative z-10" data-id="element-148" data-mp="329hpn1cbhteg">
            {['NÚMEROS Y CONTEO', 'SUMAS Y RESTAS', 'MULTIPLICACIONES', 'DIVISIONES', 'TABLAS', 'FRACCIONES', 'GEOMETRÍA', 'MEDIDAS', 'DINERO', 'GRÁFICOS', 'PORCENTAJES', 'PROBLEMAS'].map((tag, i) => <motion.span initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.3 + i * 0.05
          }} key={i} className="bg-off-white pixel-border hard-shadow px-3 py-1 font-body font-extrabold text-[#171717] text-[14px] md:text-base uppercase" data-id="element-149" data-mp="3lvb64fzqj8lq" data-mpi={i}>
                {tag}
              </motion.span>)}
          </div>
        </section>

        {/* CAROUSEL DE MUESTRAS */}
        <AutoScrollCarousel data-id="element-150" data-mp="2o7ixmpv88kyu" />

        {/* 5. LOS 5 NIVELES */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-151" data-mp="2t9rs5qnqzv32">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-152" data-mp="2f8fg3qbpkdmg">
            UN MATERIAL QUE LO ACOMPAÑA DE 1.º A 5.º DE PRIMARIA
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-153" data-mp="2prcdmintfrmq">
            {[{
            level: 1,
            grade: "1.º DE PRIMARIA",
            color: "bg-[#55A83C]",
            topics: "Números y conteo • Sumas y restas • Geometría • Medidas • Dinero",
            iconType: "grass-block"
          }, {
            level: 2,
            grade: "2.º DE PRIMARIA",
            color: "bg-[#ED8936]",
            topics: "Valor posicional • Multiplicación • División • Secuencias • Geometría y medidas",
            iconType: "gold"
          }, {
            level: 3,
            grade: "3.º DE PRIMARIA",
            color: "bg-[#4299E1]",
            topics: "Multiplicaciones • Divisiones • Fracciones • Tablas • Perímetro • Problemas",
            iconType: "diamond"
          }, {
            level: 4,
            grade: "4.º DE PRIMARIA",
            color: "bg-[#9F7AEA]",
            topics: "Operaciones • Múltiplos y divisores • Fracciones y decimales • Área • Gráficos",
            iconType: "emerald"
          }, {
            level: 5,
            grade: "5.º DE PRIMARIA",
            color: "bg-[#F56565]",
            topics: "Porcentajes • Proporciones • Volumen • Geometría • Probabilidad",
            iconType: "trophy"
          }].map((lvl, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.15
          }} key={i} className="bg-white pixel-border hard-shadow flex flex-col sm:flex-row relative overflow-hidden z-10" data-id="element-154" data-mp="hl1x37ai7cxh" data-mpi={i}>
                <div className="absolute -right-4 -bottom-4 opacity-20 drop-shadow-none pointer-events-none w-24 h-24" data-id="element-155" data-mp="3pxzh828my7s7">
                  <GameDecoration type={lvl.iconType} className="w-full h-full" data-id="element-156" data-mp="3kheab4l9h3z" />
                </div>
                <div className={`${lvl.color} p-4 border-b-4 sm:border-b-0 sm:border-r-4 border-[#111] flex flex-col justify-center items-center sm:w-1/3 relative z-10`} data-id="element-157" data-mp="32arargzh0sol">
                  <span className="font-body font-black text-white text-[20px] uppercase flex items-center gap-2" data-id="element-158" data-mp="377hq223gbk8y">
                    <GameDecoration type={lvl.iconType} className="w-6 h-6 relative" data-id="element-159" data-mp="2lyqchd4uya3p" /> NIVEL {lvl.level}
                  </span>
                  <span className="font-body font-bold text-white text-[16px] text-center mt-1 uppercase leading-tight" data-id="element-160" data-mp="27zqnu5hchv7j">{lvl.grade}</span>
                </div>
                <div className="p-4 sm:w-2/3 flex items-center" data-id="element-161" data-mp="2c2ey8hlpja6m">
                  <p className="font-body font-bold text-[#171717] text-[15px] leading-[1.4]" data-id="element-162" data-mp="1y8dxjib73d3m">{lvl.topics}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-163" data-mp="1o954cro5m2ib">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-164" data-mp="1taukglq8h6d9"></div>
        </div>

        {/* 6. BENEFICIO EMOCIONAL */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-165" data-mp="1fceamlx2qzqw">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-0 top-[40%] animate-torch-flicker" data-id="element-166" data-mp="10ncldkqtp7ww" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-0 top-[40%] animate-torch-flicker" data-id="element-167" data-mp="vpb5f8op1opn" />

          <div className="bg-off-white pixel-border hard-shadow p-6 md:p-8 max-w-[95%] mx-auto relative z-10" data-id="element-168" data-mp="19pc3kgdkqi1f">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="font-body font-extrabold text-[21px] leading-[1.15] tracking-[-0.3px] text-[#171717] mb-4 uppercase" data-id="element-169" data-mp="15lw7pm9bwlps">
              MENOS "NO QUIERO<br data-id="element-170" data-mp="1tbqp8h4leygd" />HACER MATEMÁTICA"...
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-body font-black text-[27px] leading-[1.05] tracking-[-0.5px] text-[#171717] mb-6 uppercase" data-id="element-171" data-mp="1ocnjsvkpaq7v">
              Y MÁS...<br data-id="element-172" data-mp="v18o70nrlnyd" />"¿CUÁL ES LA<br data-id="element-173" data-mp="v1qpwct74udo" /><span className="text-[#F6B900]" data-id="element-174" data-mp="v1qu6p08bgjh">PRÓXIMA MISIÓN?</span>" 🎮
            </motion.h3>
            
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#302A26] text-[16px] md:text-[18px] leading-[1.45] mb-8" data-id="element-175" data-mp="100240zqixr1p">
              No buscamos reemplazar la enseñanza escolar. Buscamos darle una forma diferente de practicar lo que necesita aprender.
            </motion.p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-176" data-mp="1nol976ea1npk">
              {['Más interés', 'Más práctica', 'Más autonomía', 'Menos resistencia'].map((item, i) => <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + i * 0.1
            }} key={i} className="group flex items-center gap-3 bg-white pixel-border p-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_#111] cursor-default" data-id="element-177" data-mp="3pghlii89r1le" data-mpi={i}>
                  <div className="bg-grass-green w-8 h-8 flex items-center justify-center flex-shrink-0 border-2 border-[#111] group-hover:bg-yellow-pixel transition-colors duration-200" data-id="element-178" data-mp="3c8qta2dsjp4i">
                    <span className="text-white font-bold text-xl leading-none animate-level-up" style={{
                  animationDelay: `${i * 0.2}s`
                }} data-id="element-179" data-mp="385cax52dqwnw">✓</span>
                  </div>
                  <span className="font-body font-bold text-[16px] text-[#171717] group-hover:text-grass-green transition-colors duration-200" data-id="element-180" data-mp="3tgsqypjuryu">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-181" data-mp="2kim841i7iy28"></div>

        {/* 7. LOS 5 BONOS */}
        <section className="bg-[#9F7AEA] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-182" data-mp="2fhge80ct94r4">
          {/* Decorative Elements */}
          <GameDecoration type="chest" className="w-[60px] md:w-[80px] top-[10%] right-[10%]" data-id="element-183" data-mp="c0i7yzs6pv8j" />
          <GameDecoration type="diamond" className="w-[30px] md:w-[40px] top-[30%] left-[5%] animate-game-float" data-id="element-184" data-mp="c2csiczjnlc3" />
          <GameDecoration type="diamond" className="w-[25px] md:w-[35px] bottom-[40%] right-[5%] animate-game-float" style={{
          animationDelay: '1s'
        }} data-id="element-185" data-mp="2afhb68jctdd" />
          <GameDecoration type="diamond" className="w-[35px] md:w-[45px] bottom-[10%] left-[10%] animate-game-float" style={{
          animationDelay: '2s'
        }} data-id="element-186" data-mp="q0t00658dfva" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[18px] text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-187" data-mp="gzv3sa11acn9">PERO ESO NO ES TODO...</motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-display text-4xl md:text-5xl text-white text-outline uppercase mb-12 leading-tight animate-mc-breathe relative z-10" data-id="element-188" data-mp="36p6x0ztaxkqc">
            🎁 TE LLEVÁS 5 BONOS GRATIS
          </motion.h2>
          
          <div className="flex flex-col gap-12 max-w-[90%] mx-auto relative z-10" data-id="element-189" data-mp="336hl6b9a6rny">
            {/* Bono 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-190" data-mp="2fgna9z8ivd6c">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-191" data-mp="2p8006larft9q">🏆</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" data-id="element-192" data-mp="2kef1er1cev9h">GRATIS</div>
              <img src={IMAGES.bonus1} alt="Tarjetas de Recompensa" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.5s'
            }} data-id="element-193" data-mp="1rrki3xg9i1xl" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-194" data-mp="lob6p1rw1rz">BONO #1</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-195" data-mp="5glrmh1dtdew">TARJETAS DE RECOMPENSA</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-196" data-mp="38vzpbosnwp6l">¡DESBLOQUEÁ SUS LOGROS!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-197" data-mp="3dv3wyazxueut">Reconocé cada actividad completada y ayudalo a mantener sus ganas de continuar.</p>
            </motion.div>

            {/* Bono 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-198" data-mp="3msmmnsoj1hd1">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-199" data-mp="1c8f6izok93gf">🧭</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.2s'
            }} data-id="element-200" data-mp="17an95q55cp4u">GRATIS</div>
              <img src={IMAGES.bonus2} alt="Mapa de Progreso" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.7s'
            }} data-id="element-201" data-mp="ygs92wivtow2" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-202" data-mp="oht0tf213v9l">BONO #2</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-203" data-mp="jkb0ue5zoqdq">MAPA DE PROGRESO</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-204" data-mp="2dykcys1kqkpj">¡QUE VEA TODO LO QUE AVANZÓ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-205" data-mp="29xicy8zu24mi">Convertí cada actividad completada en un paso visible hacia su próxima meta.</p>
            </motion.div>

            {/* Bono 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-206" data-mp="2x8wnifphaejw">
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.4s'
            }} data-id="element-207" data-mp="29h7sgrl9vbz9">GRATIS</div>
              <img src={IMAGES.bonus3} alt="Guía para Padres" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.9s'
            }} data-id="element-208" data-mp="20h2tn5u59lwp" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-209" data-mp="3uu15htvhsqm5">BONO #3</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-210" data-mp="3oj64kal3p63">GUÍA PARA PADRES Y DOCENTES</h4>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base mt-4" data-id="element-211" data-mp="dq3jrd56nvfn">Ideas prácticas para acompañar, motivar y aprovechar mejor cada actividad, tanto en casa como en el aula.</p>
            </motion.div>

            {/* Bono 4 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-212" data-mp="hs8ekf7day3v">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-213" data-mp="rlp95lfbwh8l">🧩</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.6s'
            }} data-id="element-214" data-mp="11i20wdrbcl0p">GRATIS</div>
              <img src={IMAGES.bonus4} alt="Problemas Matemáticos" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.1s'
            }} data-id="element-215" data-mp="339x9gki9w9ep" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-216" data-mp="1djwl8nw6jm34">BONO #4</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-217" data-mp="1rjxna6o6kzk6">PROBLEMAS MATEMÁTICOS</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-218" data-mp="1njniuyg1eh7f">¡DESAFÍOS PARA PENSAR!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-219" data-mp="1wi8yakq7pg3z">Situaciones para pensar, resolver y superar, llevando la lógica matemática un paso más allá.</p>
            </motion.div>

            {/* Bono 5 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-220" data-mp="268anjfuax4kh">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-221" data-mp="2f6e0vov4uv17">✖️</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.8s'
            }} data-id="element-222" data-mp="33t3l9h2wjwdw">GRATIS</div>
              <img src={IMAGES.bonus5} alt="Tabla de Multiplicar" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.3s'
            }} data-id="element-223" data-mp="2tue7o0i1gy3g" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-224" data-mp="2kvj30sun7w29">BONO #5</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-225" data-mp="266wec0j4lryd">TABLA DE MULTIPLICAR</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-226" data-mp="2b2bsyuoyjrvu">¡APRENDÉ Y DOMINÁ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-227" data-mp="223qbz3z4wkx6">Practicá las tablas paso a paso hasta memorizarlas y dominarlas por completo.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="mt-12 bg-yellow-pixel pixel-border hard-shadow p-4 inline-block max-w-[95%] relative z-10" data-id="element-228" data-mp="2w9jgul37o9v">
            <p className="font-body font-black text-[18px] md:text-[22px] text-[#171717] uppercase leading-tight" data-id="element-229" data-mp="qlkowpddu6uc">LOS 5 BONOS ESTÁN INCLUIDOS SIN COSTO EXTRA</p>
          </motion.div>
        </section>

        {/* 8. TODO LO QUE RECIBÍS */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-230" data-mp="ho1wgzxesq8f">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-231" data-mp="cmcppwh7yyq5">
            MIRÁ TODO LO QUE TE LLEVÁS HOY
          </motion.h2>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-232" data-mp="1hv707r80i4r3">
            <img src={IMAGES.packCompleto} alt="Todo lo que recibís" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-233" data-mp="1vlslfmkxuqs5" />
            
            <ul className="space-y-4 font-body font-bold text-[#171717] text-[16px] md:text-[18px] mb-10" data-id="element-234" data-mp="20jc20t53zfn9">
              <li className="flex items-center gap-3" data-id="element-235" data-mp="25k84d29tatqk"><span className="text-2xl" data-id="element-236" data-mp="29lbjtnny6nr9">📘</span> +100 Actividades de Matemáticas</li>
              <li className="flex items-center gap-3" data-id="element-237" data-mp="29j7f53i85kpx"><span className="text-2xl" data-id="element-238" data-mp="b679stlaoswa">📚</span> Contenido de 1.º a 5.º de primaria</li>
              <li className="flex items-center gap-3" data-id="element-239" data-mp="f70y3o2ng9pp"><span className="text-2xl" data-id="element-240" data-mp="f829xurhp08h">🏆</span> Tarjetas de Recompensa (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-241" data-mp="3g1gsfubvvwyy"><span className="text-2xl" data-id="element-242" data-mp="3g4l1b50angvy">🗺️</span> Mapa de Progreso (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-243" data-mp="3c0n2kvevs83f"><span className="text-2xl" data-id="element-244" data-mp="3q0fpefnae464">👨‍👩‍👧‍👦</span> Guía para Padres y Docentes (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-245" data-mp="3l1uosf44hih5"><span className="text-2xl" data-id="element-246" data-mp="3l2wd3la5g1gt">🧩</span> Problemas Matemáticos (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-247" data-mp="2xb8pbc86p6ir"><span className="text-2xl" data-id="element-248" data-mp="2xca7e0nmat9z">✖️</span> Tabla de Multiplicar (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-249" data-mp="2seif35j29559"><span className="text-2xl" data-id="element-250" data-mp="371top1vomf2q">📄</span> Material digital</li>
              <li className="flex items-center gap-3" data-id="element-251" data-mp="3734u164rzuvy"><span className="text-2xl" data-id="element-252" data-mp="32bd7d6oqq9b3">🖨️</span> Listo para imprimir</li>
              <li className="flex items-center gap-3" data-id="element-253" data-mp="329a8dx5m15u8"><span className="text-2xl" data-id="element-254" data-mp="2ekr0vjudwx37">⚡</span> Acceso inmediato</li>
            </ul>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white relative mt-6" data-id="element-255" data-mp="29n7o6odc4sdd">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-pixel text-[#111] font-body font-black text-[12px] md:text-[14px] pixel-border px-3 py-1 uppercase whitespace-nowrap" data-id="element-256" data-mp="p3cb98dcnnev">
                TODO EL MATERIAL + LOS 5 BONOS
              </div>
              
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mt-3 mb-4" data-id="element-257" data-mp="k4izbkdpo4gt">
                <div className="flex flex-col items-center" data-id="element-258" data-mp="17w6gvbp3236f">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-259" data-mp="1ctpv4bls6fyd">Valor: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-260" data-mp="yuq8talqqd5d">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-261" data-mp="3jkfizabi1arq">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-262" data-mp="3ok1xdn32cx24">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              
              <CTAButton data-id="element-263" data-mp="1p3p8bdn2e9g0" />
            </div>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-264" data-mp="1kcpb07a19pcz">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-265" data-mp="1kb4kcsquaqke"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-266" data-mp="1gbncjsnxxhc2"></div>
        </div>

        {/* 9. CÓMO FUNCIONA */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-267" data-mp="16dpmr0qfnchc">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-10 leading-tight relative z-10" data-id="element-268" data-mp="16g2do3e64x6j">
            EMPEZAR ES MUY FÁCIL
          </motion.h2>
          
          <div className="flex flex-col gap-6 max-w-[95%] mx-auto relative z-10" data-id="element-269" data-mp="2rsdlvknnup9w">
            {[{
            step: "1",
            title: "COMPRÁS",
            desc: "Realizás tu compra de forma segura."
          }, {
            step: "2",
            title: "RECIBÍS EL MATERIAL",
            desc: "Accedés al contenido digital al instante."
          }, {
            step: "3",
            title: "IMPRIMÍS Y EMPIEZAN LAS MISIONES",
            desc: "Elegí las actividades y comenzá a utilizarlas."
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.2
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4 text-left" data-id="element-270" data-mp="3qq32npmw7c3p" data-mpi={i}>
                <div className="bg-yellow-pixel pixel-border w-14 h-14 flex-shrink-0 flex items-center justify-center font-body font-black text-[24px] text-[#171717]" data-id="element-271" data-mp="8jyhfm11znep">
                  {item.step}
                </div>
                <div data-id="element-272" data-mp="1jykcc2590dy0">
                  <h3 className="font-body font-black text-[18px] md:text-[20px] text-[#171717] uppercase mb-1" data-id="element-273" data-mp="1jy2bstbjzdka">{item.title}</h3>
                  <p className="font-body font-medium text-[15px] leading-[1.45] text-[#302A26]" data-id="element-274" data-mp="vkp332bvoaxv">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-275" data-mp="znv866n97w2r">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-276" data-mp="zmahis428xa6"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-277" data-mp="1ebq3lusncejj"></div>
        </div>

        {/* 10. PARA QUIÉN ES */}
        <section className="bg-medium-brown px-4 py-12 relative overflow-hidden" data-id="element-278" data-mp="19gkhovz8uzvg">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-white text-center mb-10 uppercase relative z-10" data-id="element-279" data-mp="1nd6cfy3tc8ln">
            IDEAL PARA...
          </motion.h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-280" data-mp="3azagy4dzb82b">
            {[{
            icon: "👦",
            text: "Chicos de 1.º a 5.º de primaria"
          }, {
            icon: "🏠",
            text: "Familias que buscan reforzar matemática en casa"
          }, {
            icon: "👩‍🏫",
            text: "Docentes que buscan actividades diferentes"
          }, {
            icon: "📚",
            text: "Refuerzo escolar"
          }, {
            icon: "☀️",
            text: "Vacaciones"
          }, {
            icon: "🧠",
            text: "Práctica semanal"
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-281" data-mp="2wc7l025b17h3" data-mpi={i}>
                <span className="text-3xl" data-id="element-282" data-mp="gkjmw3ek18wp">{item.icon}</span>
                <span className="font-body font-bold text-[#171717] text-base" data-id="element-283" data-mp="lj4qmct0mapw">{item.text}</span>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-284" data-mp="1s8svjvoa0zct"></div>

        {/* 11. FAQ */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-285" data-mp="1x85i0fb8k4ev">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase relative z-10" data-id="element-286" data-mp="21z5an8dbo0bk">
            PREGUNTAS FRECUENTES
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-287" data-mp="2fzpt23fbru4j">
            {faqs.map((faq, i) => <motion.details initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="group bg-white pixel-border hard-shadow" data-id="element-288" data-mp="2kw6rbqg8novc" data-mpi={i}>
                <summary className="font-body font-black text-[16px] md:text-[18px] p-4 cursor-pointer flex justify-between items-center list-none uppercase text-[#171717]" data-id="element-289" data-mp="33vbeefiusxql">
                  <span className="pr-4" data-id="element-290" data-mp="2v1oh2kyzzmfa">{faq.q}</span>
                  <span className="text-2xl group-open:rotate-180 transition-transform" data-id="element-291" data-mp="2v03qt7jpupn8">▼</span>
                </summary>
                <div className="p-4 pt-0 font-body font-medium text-[15px] leading-[1.45] text-[#302A26] border-t-4 border-[#111]" data-id="element-292" data-mp="3mtdta1hoteao">
                  {faq.a}
                </div>
              </motion.details>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-293" data-mp="3duirr2pl8sdp">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-294" data-mp="38stfjjqmq8o1"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-295" data-mp="22dsonsggogob"></div>
        </div>

        {/* 12. CTA FINAL */}
        <section className="bg-sky-blue px-4 py-16 text-center relative overflow-hidden" data-id="element-296" data-mp="1xdo4nsgch3tc">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-[5%] top-[30%] animate-torch-flicker" data-id="element-297" data-mp="1ytilro9c4mst" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-[5%] top-[30%] animate-torch-flicker" data-id="element-298" data-mp="1pux2trzyb5ri" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[60px] right-[20%] bottom-[30%] animate-game-float" data-id="element-299" data-mp="1uti3fsj47rgh" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[50px] left-[10%] bottom-[-10px]" data-id="element-300" data-mp="1g42fekayy04h" />
          <GameDecoration type="grass-block" className="w-[30px] md:w-[40px] left-[25%] bottom-[-5px]" data-id="element-301" data-mp="1kwlujlpb13be" />
          <GameDecoration type="grass-block" className="w-[50px] md:w-[60px] right-[15%] bottom-[-15px]" data-id="element-302" data-mp="175qk44z5qe5p" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-6 leading-tight relative z-10" data-id="element-303" data-mp="1b6k26hpx4yqo">
            HOY PUEDE SER EL DÍA EN QUE PRACTICAR MATEMÁTICA DEJE DE SER UNA PELEA.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-[16px] md:text-[18px] bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-304" data-mp="dm0pdpni9nw3">
            Transformá sus ejercicios en desafíos que realmente tenga ganas de completar.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-off-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-305" data-mp="1b8rdgkp3ycol">
            <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-306" data-mp="1k6jqtjb9ra9c" />
            
            <div className="flex flex-col gap-3 mb-8" data-id="element-307" data-mp="39qjoj1j73w3v">
              <span className="bg-grass-green text-white font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-308" data-mp="39nxi5581jmn8">+100 ACTIVIDADES</span>
              <span className="bg-yellow-pixel text-[#111] font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-309" data-mp="3jfbex58ly8co">+ 5 BONOS GRATIS</span>
            </div>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white mb-6" data-id="element-310" data-mp="2qr5teg9qcfbs">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mb-4" data-id="element-311" data-mp="2vq8z82xjapkt">
                <div className="flex flex-col items-center" data-id="element-312" data-mp="30plh099jt6gj">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-313" data-mp="30o21wlzmp1gc">Antes: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-314" data-mp="34olz1pk7c52h">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-315" data-mp="jz4zfb33g0o5">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-316" data-mp="24kv0ee9ndduy">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              <CTAButton data-id="element-317" data-mp="1vovma9vrry86" />
            </div>
          </motion.div>
        </section>
        
        {/* Footer */}
        <footer className="bg-[#111] text-gray-400 py-8 px-4 text-center font-body font-bold text-xs border-t-4 border-[#111] relative z-10" data-id="element-318" data-mp="1qp9be73eyu2j">
          <p className="mb-2" data-id="element-319" data-mp="1gso41f3x96vj">© {new Date().getFullYear()} Lectura Mundo Bloques. Todos los derechos reservados.</p>
          <p data-id="element-320" data-mp="1csm2d5y6sdg9">Este producto no está asociado, afiliado, respaldado, certificado ni patrocinado por Mojang AB o Microsoft. Minecraft es una marca registrada de Mojang Synergies AB.</p>
        </footer>

      </div>
    </div>;
}